import React, { ChangeEvent } from "react";
import { SelectEvent } from "../Models/multiSelectEvent";

interface ListItemSelectorProps {
  index: number;
  onRowSelectChange: (event: SelectEvent) => void;
  initialValue: boolean;
  disabled?: boolean;
}

export function ListItemSelector({
  index,
  onRowSelectChange,
  initialValue,
  disabled = false,
}: ListItemSelectorProps) {
  function onChange(e: ChangeEvent<HTMLInputElement>) {
    if (!disabled) {
      onRowSelectChange({ index, checked: e.target.checked });
    }
  }

  return (
    <div
      className="w-14 flex justify-center items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div>
        <label
          className={`container ${
            disabled ? "opacity-50" : "hover:opacity-50"
          }`}
          // Inline style, not the cursor-default utility: CheckBox.css's
          // `.container { cursor: pointer }` and the utility have equal
          // specificity, so the winner used to depend on emission order in
          // main.css (and would flip when a lazy chunk's CSS loaded). The
          // inline style pins the intended disabled-arrow cursor regardless
          // of stylesheet order.
          style={disabled ? { cursor: "default" } : undefined}
        >
          <input
            checked={!!initialValue}
            type="checkbox"
            onChange={(e) => onChange(e)}
            disabled={disabled}
            className={`w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600 ${
              disabled ? "cursor-not-allowed" : "hover:bg-gray-50"
            }`}
          />
          <span className={`checkmark ${disabled ? "opacity-50" : ""}`}></span>
        </label>
      </div>
    </div>
  );
}
